import React from "react";

const FiltresAlimentation = ({ annonces, filters, onChange }) => {
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const updatedFilters = { ...filters };

    if (type === "checkbox") {
      updatedFilters[name] = checked
        ? [...(filters[name] || []), value]
        : filters[name].filter((v) => v !== value);
    } else {
      updatedFilters[name] = value;
    }

    onChange(updatedFilters);
  };

  const uniqueTypeAliments = [...new Set(annonces.map((a) => a.typeAliment).filter(Boolean))];
  const uniqueConservation = [...new Set(annonces.map((a) => a.conservation).filter(Boolean))];

  return (
    <div>
      <h3>Type d'aliment</h3>
      {uniqueTypeAliments.map((type) => (
        <label key={type}>
          <input
            type="checkbox"
            name="typeAliment"
            value={type}
            onChange={handleChange}
          />
          {type}
        </label>
      ))}

      <h3>Type de conservation</h3>
      {uniqueConservation.map((conserv) => (
        <label key={conserv}>
          <input
            type="checkbox"
            name="conservation"
            value={conserv}
            onChange={handleChange}
          />
          {conserv}
        </label>
      ))}

      <h3>Prix</h3>
      <label>
        Min:
        <input
          type="number"
          name="prixMin"
          value={filters.prixMin}
          onChange={handleChange}
          placeholder="Prix minimum"
        />
      </label>
      <label>
        Max:
        <input
          type="number"
          name="prixMax"
          value={filters.prixMax}
          onChange={handleChange}
          placeholder="Prix maximum"
        />
      </label>
    </div>
  );
};

export default FiltresAlimentation;
